import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// utils
import MyButton from "../../util/MyButton";
import PostPost from "../post/Postpost";
import Notifications from "./Notifications";
import AppIcon from "../../images/full-logo.png";
import Emoji from "../widgets/Emoji";

// MUI imports
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import AccountCircle from "@material-ui/icons/AccountCircle";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";

//import { useLocation } from "react-router-dom";

const styles = (theme) => ({
  ...theme.spreadThis,
  toolBar: {
    margin: "auto",
    maxWidth: 1250, //hardcoded for now
    width: "100%",
  },
  // this group of buttons will be aligned to the right side
  toolbarButtons: {
    marginLeft: "auto",
  },
});

class Navbar extends Component {
  render() {
    const {
      classes,
      user: {
        //credentials: { handle },
        userProfile: { handle },
        // loading,
        authenticated,
      },
    } = this.props;

    // check if the route is the landing route, show landing nav bar
    // otherwise show true navbar
    if (this.props.location.pathname === "/") {
      return (
        <AppBar color="secondary">
          <Toolbar className={classes.toolBar}>
            <Link to={"/"}>
              <img src={AppIcon} alt="fitcheck" height="25%" width="75%" />
            </Link>
            <div className={classes.toolbarButtons}>
              <Fragment>
                <Button color="inherit" component={Link} to="/login">
                  Login
                </Button>
              </Fragment>
            </div>
          </Toolbar>
        </AppBar>
      );
    } else {
      return (
        <AppBar color="secondary">
          <Toolbar className={classes.toolBar}>
            <Link to={"/home"}>
              <Tooltip title="Home">
                <img src={AppIcon} alt="fitcheck" height="25%" width="75%" />
              </Tooltip>
            </Link>
            {/*<h4>SEARCH BAR HERE</h4>*/}
            <div className={classes.toolbarButtons}>
              {authenticated ? (
                <Fragment>
                  <PostPost />
                  <Notifications />
                  <MyButton tip="For you!">
                    <Emoji symbol="😎" label="cool" />
                  </MyButton>
                  <Link to={"/wardrobe"} style={{ textDecoration: "none" }}>
                    <MyButton tip="Your wardrobe!">
                      <Emoji symbol="✔️" label="briefcase" />
                    </MyButton>
                  </Link>
                  <Link to={`/users/${handle}`}>
                    <MyButton tip={handle}>
                      <AccountCircle />
                    </MyButton>
                  </Link>
                </Fragment>
              ) : (
                <Fragment>
                  <Button color="inherit" component={Link} to="/login">
                    Login
                  </Button>{" "}
                  <Button
                    component={Link}
                    variant="contained"
                    color="primary"
                    to="/signup"
                  >
                    Signup
                  </Button>
                </Fragment>
              )}
            </div>
            <a
              href="https://forms.gle/FToTtFEh9qZbxpkQ8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MyButton tip="Submit an issue!">
                <HelpIcon />
              </MyButton>
            </a>
          </Toolbar>
        </AppBar>
      );
    }
  }
}

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  authenticated: state.user.authenticated,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Navbar)));
